import {Tooltip} from "antd";
import {
	Button, Icon
} from "~/components";

function PendingReceiptAction({item, onClickEdit, onClickResolve, onClickDelete}) {

	const isPending = item?.status?.key !== 'resolved';

	return (
		<div className="table-action d-flex">
			<Tooltip title="Xác định nguồn">
				<Button background green leftIcon={Icon.success} onClick={() => onClickResolve && onClickResolve(item)}></Button>
			</Tooltip>
			{isPending && (
				<Tooltip title="Sửa thông tin">
					<Button background blue leftIcon={Icon.edit} onClick={() => onClickEdit && onClickEdit(item)}></Button>
				</Tooltip>
			)}
			{isPending && (
				<Tooltip title="Xóa">
					<Button background red leftIcon={Icon.delete} onClick={() => onClickDelete && onClickDelete(item)}></Button>
				</Tooltip>
			)}
		</div>
	)
}

export default PendingReceiptAction;
